/* Auto-generated UI locale pack for ArcVPN dashboard namespaces */
export const uiPack = {
  en: {
    "admin": {
      "downloads": {
        "add": "Add platform",
        "architectures": "Architectures",
        "count": "Downloads",
        "created": "Download created",
        "createTitle": "Add platform",
        "deleteConfirm": "Delete this download platform?",
        "deleted": "Download deleted",
        "deleteError": "Delete failed",
        "editTitle": "Edit platform",
        "emptyDesc": "Add a client build to publish on the downloads page.",
        "emptyTitle": "No platforms yet",
        "hidden": "Hidden",
        "hide": "Hide",
        "invalidJson": "System requirements must be valid JSON",
        "kicker": "Client builds",
        "loadError": "Failed to load downloads",
        "order": "Order",
        "requirements": "Requirements",
        "saveError": "Save failed",
        "show": "Show",
        "size": "Size",
        "stats": {
          "count": "Total downloads",
          "hidden": "Hidden",
          "total": "Platforms",
          "visible": "Visible"
        },
        "subtitle": "Publish platform builds, requirements, checksums, and release notes.",
        "systemReq": "System requirements",
        "title": "Downloads",
        "type": "Type",
        "updated": "Download updated",
        "version": "Version",
        "visibilityError": "Could not change visibility",
        "visibilityUpdated": "Visibility updated",
        "visible": "Visible"
      }
    },
    "adminTickets": {
      "allAssigned": "All assignees",
      "allPriority": "All priority",
      "allStatus": "All",
      "assigned": "Ticket assigned to you",
      "assignedToMe": "Assigned to me",
      "assignedToYou": "Assigned to you",
      "assignee": "Assigned",
      "assignToMe": "Assign to me",
      "attachmentError": "Failed to download attachment",
      "attachmentMissing": "Attachment data not available",
      "declined": "Declined",
      "detailError": "Failed to load ticket",
      "high": "High",
      "inProcess": "In process",
      "kicker": "Support console",
      "loadError": "Failed to load tickets",
      "low": "Low",
      "normal": "Normal",
      "noTickets": "No tickets found",
      "noTicketsDesc": "Adjust filters or wait for new support requests.",
      "noUser": "Current admin user not available",
      "open": "Open",
      "priority": "Priority",
      "replyError": "Failed to send reply",
      "replyPlaceholder": "Type your response…",
      "search": "Search tickets…",
      "selectTicket": "Select a ticket",
      "selectTicketDesc": "Choose a conversation from the list to review messages and reply.",
      "solved": "Solved",
      "status": "Status",
      "subtitle": "Triage requests, assign ownership, and reply with attachments.",
      "support": "Support",
      "title": "Support tickets",
      "today": "Today",
      "unassigned": "Unassigned",
      "updateError": "Failed to update ticket",
      "urgent": "Urgent"
    },
    "checkout": {
      "amount": "Amount",
      "back": "Back to plans",
      "cardName": "Name on card",
      "cardNumber": "Card number",
      "company": "Company",
      "email": "Billing email",
      "expiry": "Expiry",
      "kicker": "Secure checkout",
      "loading": "Preparing payment…",
      "paid": "Paid",
      "paidAt": "Paid at",
      "paidKicker": "Payment complete",
      "paidTitle": "You’re upgraded",
      "pay": "Pay",
      "paymentDetails": "Payment details",
      "plan": "Plan",
      "processing": "Processing…",
      "status": "Status",
      "summary": "Order summary",
      "title": "Complete payment",
      "toBilling": "View company billing",
      "toDashboard": "Back to dashboard",
      "totalDue": "Total due today",
      "planNotFound": "Plan not found.",
      "paymentFailed": "Payment failed.",
      "demoNote": "Demo · No real charge",
      "paidLead": "{{plan}} is now active. (Demo payment)",
      "demoLead": "This is a demo payment screen. Card details are not processed; Pay upgrades your plan and creates an invoice.",
      "loadPlanError": "Could not load plan.",
      "customPrice": "Custom",
      "loadFailed": "Failed to load checkout"
    },
    "common": {
      "back": "Back to Admin",
      "cancel": "Cancel",
      "close": "Close",
      "create": "Create",
      "delete": "Delete",
      "downloading": "Downloading…",
      "edit": "Edit",
      "loading": "Loading…",
      "ok": "OK",
      "refresh": "Refresh",
      "remove": "Remove",
      "save": "Save changes",
      "saving": "Saving…",
      "sending": "Sending…",
      "submitting": "Submitting…"
    },
    "company": {
      "cta": {
        "invite": "Invite teammate",
        "upgrade": "View plans"
      },
      "invite": {
        "button": "Send invite",
        "createdNoEmail": "Invite created. Share this code: {{code}}",
        "failed": "Failed to send invitation",
        "heading": "Add a teammate",
        "help": "We email an invite code. They can join during signup with that code.",
        "noSeat": "No seat",
        "oneSeat": "1 seat available",
        "placeholder": "name@company.com",
        "seatsLeft": "{{left}} seats available",
        "sending": "Sending…",
        "sent": "Invitation sent to {{email}}",
        "title": "Invite"
      },
      "invites": {
        "acceptedNote": "{{count}} invite(s) already accepted.",
        "cancel": "Cancel",
        "cancelFailed": "Failed to cancel invitation",
        "cancelled": "Invitation cancelled",
        "copied": "Invite code copied",
        "copiedShort": "Copied",
        "copy": "Copy code",
        "copyFailed": "Could not copy code",
        "empty": "No pending invitations.",
        "pending": "Pending",
        "sentOn": "Sent {{date}}",
        "title": "Invitations"
      },
      "invoices": {
        "amount": "Amount",
        "contact": "Contact sales",
        "date": "Date",
        "dueDate": "Due",
        "empty": "No invoices yet",
        "emptyDesc": "When billing starts, invoices will appear here.",
        "history": "Invoice history",
        "plan": "Plan",
        "status": "Status",
        "title": "Billing"
      },
      "kicker": "Company",
      "lead": "Manage seats, invites, plan limits, and billing from one place.",
      "leadMobile": "Manage seats, invites, and billing.",
      "license": {
        "active": "Active",
        "expiresAt": "Expires",
        "inactive": "Inactive",
        "maxConnections": "Connections",
        "noExpiry": "No expiry",
        "status": "Status",
        "title": "Current plan",
        "upgrade": "Upgrade plan"
      },
      "loadError": "Failed to load company information",
      "loading": "Loading company…",
      "plan": {
        "connections": "connections",
        "contact": "Contact us",
        "custom": "Custom",
        "unlimitedConnections": "Unlimited connections",
        "unlimitedUsers": "Unlimited users",
        "users": "users"
      },
      "stats": {
        "connections": "Active links",
        "pending": "Pending invites",
        "seats": "Seats"
      },
      "tabs": {
        "billing": "Billing",
        "overview": "Overview",
        "team": "Team"
      },
      "team": {
        "active": "Active",
        "admin": "Admin",
        "directory": "Directory",
        "empty": "No members loaded yet.",
        "inactive": "Inactive",
        "joined": "Joined",
        "manage": "Manage",
        "member": "Member",
        "members": "Members",
        "none": "No members match your search.",
        "pendingNote": "{{count}} pending invite(s) waiting to be accepted.",
        "role": "Role",
        "search": "Search members…",
        "snapshot": "Team snapshot",
        "status": "Status",
        "user": "User"
      },
      "untitled": "Your company",
      "upgrade": {
        "current": "Current plan",
        "heading": "Choose a better fit",
        "title": "Plans",
        "demoNote": "Demo checkout upgrades the plan and creates an invoice."
      },
      "users": {
        "title": "Team seats"
      }
    },
    "connections": {
      "activeConnections": "Active",
      "activeNow": "Active now",
      "avgDuration": "Avg duration",
      "companyConnections": "Company sessions",
      "connectionsThisWeek": "This week",
      "connectionsToday": "Today",
      "disconnectConfirm": "End this connection session?",
      "disconnected": "Connection ended",
      "disconnectError": "Could not end connection",
      "ending": "Ending…",
      "endSession": "End session",
      "filter": {
        "active": "Active",
        "all": "All",
        "ended": "Ended"
      },
      "footer": "{{count}} sessions shown",
      "kicker": "Sessions",
      "lead": "Live tunnel activity across your account — latency-ready overview of who is connected, where, and for how long.",
      "leadMobile": "Tap a session to see details.",
      "liveSession": "Live session",
      "loading": "Loading sessions…",
      "mostUsedServer": "Top server",
      "myConnections": "My sessions",
      "noData": "No sessions found",
      "noDataDesc": "Connect from the dashboard to see live tunnel activity here.",
      "pastSession": "Past session",
      "search": "Search sessions…",
      "select": "Select a session",
      "selectDesc": "Pick a tunnel from the left to inspect route, timing, and transfer.",
      "signalEnded": "This tunnel is closed. Historical transfer totals remain available.",
      "signalLive": "Encrypted tunnel is active. Metrics refresh every 15 seconds.",
      "status": {
        "active": "Live",
        "disconnected": "Ended"
      },
      "table": {
        "data": "Transferred",
        "duration": "Duration",
        "ipAddress": "Client IP",
        "startTime": "Started",
        "status": "Status",
        "user": "User"
      },
      "title": "Connections",
      "totalData": "Total data",
      "uniqueUsersToday": "Users today",
      "upDown": "Up / Down"
    },
    "dashboard": {
      "actions": {
        "clients": "Get clients",
        "sessions": "View sessions"
      },
      "disconnect": "End session",
      "disconnectFailed": "Disconnect failed",
      "ending": "Ending…",
      "greeting": {
        "afternoon": "Good afternoon",
        "evening": "Good evening",
        "morning": "Good morning",
        "night": "Good night"
      },
      "kicker": "Operations",
      "lead": "Your secure network at a glance — live tunnels, regions, and recent sessions.",
      "leadMobile": "Pick a region below to connect.",
      "live": {
        "choose": "Choose a region to connect",
        "idle": "Idle",
        "protected": "Protected"
      },
      "quick": {
        "clients": "Client apps",
        "get": "Get",
        "notifications": "Unread alerts",
        "recent": "Recent sessions",
        "tickets": "Open tickets"
      },
      "recent": {
        "all": "All",
        "empty": "No sessions yet",
        "emptyDesc": "Connect to a region to start your first tunnel.",
        "kicker": "History",
        "title": "Recent sessions"
      },
      "regions": {
        "count": "regions",
        "empty": "No regions published yet",
        "emptyDesc": "Approved servers will appear here.",
        "kicker": "Network",
        "load": "load",
        "noServers": "No servers in this region.",
        "online": "online",
        "title": "Global regions",
        "unknown": "Unknown",
        "upgrade": "Upgrade"
      },
      "stats": {
        "connections": "Active",
        "connectionTime": "Time online",
        "data": "Data used",
        "servers": "Servers",
        "today": "Sessions today"
      },
      "status": {
        "ended": "Ended",
        "live": "Live"
      },
      "tunnel": {
        "duration": "Duration",
        "live": "Live tunnel",
        "started": "Started",
        "transfer": "Transfer"
      },
      "upgrade": "Upgrade",
      "upgradeAskAdmin": "Someone with company management permission can upgrade the package.",
      "verification": {
        "button": "Verify now",
        "kicker": "Verify",
        "message": "Verify your email to unlock secure connections.",
        "title": "Confirm your email"
      }
    },
    "downloads": {
      "arch": "Architectures",
      "changelog": "Release notes",
      "channel": "Channel",
      "client": "Client",
      "defaultDesc": "Secure ArcVPN client for your organization.",
      "download": "Download",
      "features": "Client features",
      "filter": {
        "all": "All",
        "desktop": "Desktop",
        "mobile": "Mobile"
      },
      "install": "Install",
      "kicker": "Clients",
      "latest": "Latest line",
      "leadMobile": "Choose a platform, then download.",
      "minOs": "Minimum OS",
      "noDownloads": "No downloads available yet",
      "noDownloadsDesc": "Please check back shortly.",
      "noReqs": "No detailed requirements published yet.",
      "openStore": "Open store",
      "platforms": "Platforms",
      "reqHint": "Hardware and OS baseline for this client.",
      "requirements": "System requirements",
      "size": "Size",
      "subtitle": "Polished apps for every platform your team uses — with clear requirements and release details.",
      "title": "ArcVPN clients",
      "type": {
        "link": "Direct link",
        "store": "Store"
      },
      "unavailable": {
        "message": "This build is not published yet. Please try again shortly.",
        "title": "Client being updated"
      },
      "updated": "Updated",
      "version": "Version"
    },
    "errors": {
      "sessionExpired": "Session expired. Please login again."
    },
    "notifications": {
      "allCaughtUp": "You’re all caught up",
      "allMarked": "All notifications marked as read",
      "daysAgo": "{{count}}d ago",
      "delete": "Delete",
      "deleteError": "Could not delete notification",
      "empty": "No notifications yet",
      "emptyDesc": "New activity will appear here automatically.",
      "filter": {
        "all": "All",
        "read": "Read",
        "unread": "Unread"
      },
      "hoursAgo": "{{count}}h ago",
      "justNow": "Just now",
      "kicker": "Inbox",
      "lead": "Connection events, support updates, and system messages in one place.",
      "loadError": "Could not load notifications",
      "markAll": "Mark all read",
      "markError": "Could not mark notifications as read",
      "markRead": "Mark read",
      "minsAgo": "{{count}}m ago",
      "showing": "Showing",
      "title": "Notifications",
      "total": "Total",
      "unread": "{{count}} unread",
      "unreadLabel": "Unread",
      "viewAll": "View all notifications"
    },
    "pricing": {
      "contactBtn": "Contact Sales",
      "contactUs": "Contact Us",
      "freeBtn": "Start Free",
      "month": "month",
      "plans": {
        "enterprise": {
          "name": "Enterprise"
        },
        "free": {
          "description": "Start for free",
          "feature1": "1 User",
          "feature2": "1 Connection",
          "feature3": "Basic Support",
          "name": "Free"
        },
        "professional": {
          "name": "Professional"
        },
        "starter": {
          "name": "Starter"
        }
      },
      "popular": "Most Popular",
      "startBtn": "Get Started"
    },
    "profile": {
      "fields": {
        "company": "Company",
        "email": "Email",
        "license": "License",
        "memberSince": "Member Since",
        "role": "Role",
        "username": "Username"
      },
      "kicker": "Account",
      "leadMobile": "Your account details and security.",
      "password": {
        "confirm": "Confirm New Password",
        "current": "Current Password",
        "errors": {
          "allFieldsRequired": "All fields are required",
          "failed": "Failed to change password",
          "passwordsDontMatch": "New passwords do not match",
          "passwordTooShort": "Password must be at least 6 characters"
        },
        "new": "New Password",
        "save": "Change Password",
        "success": "Password changed successfully",
        "title": "Change Password"
      },
      "roles": {
        "companyAdmin": "Company Admin",
        "systemAdmin": "System Admin",
        "user": "User"
      },
      "security": {
        "changePassword": "Change Password",
        "password": "Password",
        "passwordHint": "Change your password to keep your account secure",
        "title": "Security"
      },
      "subtitle": "Manage your account settings",
      "title": "Profile",
      "unverified": "Not Verified",
      "verified": "Verified"
    },
    "sidebar": {
      "admin": "System Admin",
      "company": "My Company",
      "connections": "Connections",
      "dashboard": "Dashboard",
      "downloads": "Downloads",
      "logout": "Logout",
      "logoutConfirm": "Are you sure you want to log out?",
      "logoutConfirmTitle": "Log out?",
      "mobileNav": "Main navigation",
      "more": "More",
      "premiumPackage": "Company premium package",
      "profile": "Profile",
      "short": {
        "admin": "Admin",
        "apps": "Apps",
        "company": "Company",
        "help": "Help",
        "home": "Home",
        "links": "Links"
      },
      "tickets": "Support",
      "upgradeCta": "Upgrade",
      "viewPlanCta": "View package"
    },
    "systemAdmin": {
      "back": "Back",
      "companies": {
        "deleteFailed": "Failed to delete company",
        "deleteSuccess": "Company deleted successfully",
        "licenseUpdateFailed": "Failed to update license",
        "licenseUpdateSuccess": "License updated successfully",
        "loadDetailsFailed": "Failed to load company details",
        "updateFailed": "Failed to update company",
        "updateSuccess": "Company updated successfully"
      },
      "endpoints": {
        "col": {
          "agent": "Agent",
          "heartbeat": "Last heartbeat",
          "load": "Load",
          "location": "Location",
          "node": "Node",
          "status": "Status"
        },
        "empty": "No endpoints yet",
        "emptyLead": "Create a register key and onboard an agent to see nodes here.",
        "lead": "Truthful agent status from websocket + heartbeat — not stale DB flags.",
        "loading": "Loading endpoints…",
        "open": "Open servers",
        "title": "Endpoints"
      },
      "kicker": "Control plane",
      "leadMobile": "Platform health and admin modules.",
      "menuLabel": "Admin modules",
      "open": "Open",
      "openLogs": "View logs",
      "openServers": "Manage servers",
      "servers": {
        "addServer": "Deploy server",
        "agentStatus": {
          "connected": "Connected",
          "disconnected": "Disconnected",
          "pending": "Pending"
        },
        "card": {
          "approve": "Approve",
          "load": "Load",
          "reject": "Reject",
          "settings": "Settings",
          "users": "Users"
        },
        "deleteError": "An error occurred while deleting the server",
        "deleteSuccess": "Server deleted successfully!",
        "editBeforeApprove": "Configure before approve",
        "editPending": {
          "approveBtn": "Approve & save",
          "location": "Location",
          "name": "Server name",
          "selectLocation": "Select a location",
          "visibilityNote": "Server will be hidden from users after approval. You can make it visible later."
        },
        "empty": {
          "description": "Deploy a server over SSH to register an agent here.",
          "title": "No servers yet"
        },
        "filter": {
          "all": "All",
          "label": "Country"
        },
        "keyCreateError": "An error occurred while creating the register key",
        "keyCreateSuccess": "New register key created!",
        "keyRevokeError": "An error occurred while revoking the key",
        "keyRevokeSuccess": "Key revoked successfully!",
        "loading": "Loading servers…",
        "locationCreateSuccess": "Location created successfully!",
        "locationDeleteError": "An error occurred while deleting the location",
        "locationDeleteSuccess": "Location deleted successfully!",
        "locationSaveError": "An error occurred while saving the location",
        "locationUpdateSuccess": "Location updated successfully!",
        "pendingModal": {
          "approve": "Approve",
          "noPending": "No pending servers",
          "reject": "Reject",
          "title": "Pending servers"
        },
        "retry": "Retry",
        "saveError": "An error occurred while saving settings",
        "stats": {
          "activeUsers": "Active users",
          "avgLoad": "Avg load",
          "onlineServers": "Online",
          "totalServers": "Total"
        },
        "status": {
          "maintenance": "Maintenance",
          "offline": "Offline",
          "online": "Online"
        },
        "subtitle": "Deploy edges over SSH, approve nodes, set optional failover, manage register keys.",
        "title": "Servers",
        "toggleError": "An error occurred while changing server status",
        "visibilityError": "Failed to toggle visibility",
        "visibilityToggled": "Server visibility updated"
      },
      "stats": {
        "companies": "Companies",
        "connections": "Active tunnels",
        "errors": "Errors 24h",
        "liveAgents": "Live agents",
        "openTickets": "Open tickets",
        "servers": "Servers online",
        "users": "Users",
        "visible": "Visible nodes"
      },
      "statsError": "Could not load live metrics",
      "subtitle": "Live platform health — users, agents, endpoints, and operational signals.",
      "title": "System Admin"
    },
    "tickets": {
      "active": "Active",
      "allTickets": "All",
      "attach": "Attach",
      "attachment": "Attachment",
      "category": "Category",
      "chooseFile": "Choose a file",
      "closedNotice": "This ticket is closed. Open a new ticket if you still need help.",
      "created": "Ticket created successfully! Ticket #{{number}}",
      "createFirst": "Create your first ticket",
      "createTicket": "Create ticket",
      "createTicketTitle": "Tell us what happened",
      "emailShort": "Email",
      "fileTooLarge": "File too large. Maximum size is 2MB",
      "fillRequired": "Please fill in subject and message",
      "heroLead": "Open a ticket for connection, account, or billing issues. Our team replies in this thread.",
      "heroTitle": "How can we help?",
      "inProcess": "In process",
      "kicker": "Support",
      "leadMobile": "Open a ticket or pick one below to continue.",
      "loading": "Loading tickets…",
      "message": "Message",
      "messagePlaceholder": "Describe your issue in detail…",
      "messages": "messages",
      "messageSent": "Message sent",
      "newTicket": "New ticket",
      "noTickets": "No tickets yet",
      "noTicketsDesc": "Create a ticket and we will follow up in this inbox.",
      "open": "Open",
      "priority": "Priority",
      "priorityHigh": "High",
      "priorityLow": "Low",
      "priorityNormal": "Normal",
      "priorityUpdated": "Priority updated",
      "priorityUrgent": "Urgent",
      "replyPlaceholder": "Write a reply…",
      "search": "Search tickets…",
      "selectCategory": "Select a category",
      "selectTicket": "Select a ticket",
      "selectTicketDesc": "Choose a conversation on the left, or open a new request.",
      "send": "Send",
      "solved": "Solved",
      "statusUpdated": "Status updated",
      "subject": "Subject",
      "subjectPlaceholder": "Brief description of your issue",
      "submit": "Submit ticket",
      "supportTeam": "Support",
      "total": "Total",
      "declined": "Declined",
      "topicConnectTitle": "Connection issue",
      "topicConnectHint": "VPN will not connect or keeps dropping",
      "topicConnectSubject": "Connection issue",
      "topicAccountTitle": "Account & access",
      "topicAccountHint": "Users, invites, or login problems",
      "topicAccountSubject": "Account and access",
      "topicBillingTitle": "Plan & billing",
      "topicBillingHint": "Licenses, invoices, or upgrades",
      "topicBillingSubject": "Plan and billing",
      "justNow": "just now",
      "minsAgo": "{{n}}m",
      "hoursAgo": "{{n}}h",
      "daysAgo": "{{n}}d",
      "detailsLabel": "Details:"
    },
    "upgrade": {
      "buy": "Buy & upgrade",
      "current": "Current plan",
      "kicker": "Company package",
      "leadAdmin": "Pick a plan, complete the demo checkout, and your company upgrades instantly with an invoice.",
      "leadMember": "Only a user with company management permission can upgrade this package.",
      "loading": "Loading plan…",
      "lockedBody": "Someone with company management permission can change the company package. Ask your company admin to upgrade.",
      "lockedTitle": "Upgrade not available",
      "plans": {
        "basic": "Basic",
        "enterprise": "Enterprise",
        "free": "Free",
        "pro": "Pro"
      },
      "title": "Premium package",
      "leadAdminShort": "Pick a plan → demo pay → upgrade.",
      "leadMemberShort": "Only a company admin can upgrade.",
      "demoNote": "Demo payment: cards are not charged. After pay, an invoice is created and the plan activates immediately."
    },
    "connectModal": {
      "serverFallback": "server",
      "titleConnect": "Connect · {{location}}",
      "titleConnected": "Connected · {{location}}",
      "kickerReady": "Tunnel ready",
      "kickerSecure": "Secure tunnel",
      "close": "Close",
      "load": "Load",
      "protocol": "Protocol",
      "configReady": "Config ready",
      "waiting": "Waiting",
      "leadBefore": "Generate a one-time WireGuard configuration for this endpoint. Scan the QR on mobile or import the file on desktop.",
      "step1": "Encrypted peer keys are created server-side",
      "step2": "Config includes DNS and endpoint routing",
      "step3": "Import once — toggle the tunnel in WireGuard",
      "leadAfter": "Your VPN profile is ready. Scan with the WireGuard app or download the config file.",
      "tabQr": "QR code",
      "tabConfig": "Config text",
      "scanHint": "Open WireGuard → Scan QR code",
      "copied": "Copied",
      "copyConfig": "Copy config",
      "vpnIp": "VPN IP",
      "server": "Server",
      "dns": "DNS",
      "cancel": "Cancel",
      "connecting": "Connecting…",
      "connect": "Connect",
      "downloadConf": "Download .conf",
      "done": "Done",
      "connectFailed": "Failed to connect"
    },
    "careers": {
      "title": "Careers",
      "subtitle": "We grow with people who keep the product calm and the operations sharp.",
      "whyTitle": "Why ArcVPN",
      "whyFocusTitle": "Focus",
      "whyFocusBody": "Work close to real customer problems — not noisy roadmaps.",
      "whyOwnershipTitle": "Ownership",
      "whyOwnershipBody": "Small teams, clear responsibility, visible impact.",
      "whyFlexibilityTitle": "Flexibility",
      "whyFlexibilityBody": "Hybrid work with an outcome-first pace.",
      "whyLearningTitle": "Learning",
      "whyLearningBody": "Grow across security, networking, and product craft.",
      "openTitle": "Open roles",
      "emptyTitle": "No open roles right now",
      "emptyBody": "If something here resonates, send your CV or LinkedIn. We’ll reach out when a matching role opens.",
      "cta": "Send email",
      "email": "info@arcyintel.com",
      "mailSubject": "ArcVPN application"
    }
  },
  tr: {
    "admin": {
      "downloads": {
        "add": "Platform ekle",
        "architectures": "Mimari",
        "count": "İndirmeler",
        "created": "İndirme oluşturuldu",
        "createTitle": "Platform ekle",
        "deleteConfirm": "Bu indirme platformunu silmek istiyor musunuz?",
        "deleted": "İndirme silindi",
        "deleteError": "Silme başarısız",
        "editTitle": "Platformu düzenle",
        "emptyDesc": "İndirmeler sayfasında yayınlamak için istemci derlemesi ekleyin.",
        "emptyTitle": "Henüz platform yok",
        "hidden": "Gizli",
        "hide": "Gizle",
        "invalidJson": "Sistem gereksinimleri geçerli JSON olmalı",
        "kicker": "İstemci derlemeleri",
        "loadError": "İndirmeler yüklenemedi",
        "order": "Sıra",
        "requirements": "Gereksinimler",
        "saveError": "Kaydetme başarısız",
        "show": "Göster",
        "size": "Boyut",
        "stats": {
          "count": "Toplam indirme",
          "hidden": "Gizli",
          "total": "Platformlar",
          "visible": "Görünür"
        },
        "subtitle": "Platform derlemelerini, gereksinimleri, sağlama toplamlarını ve sürüm notlarını yayınlayın.",
        "systemReq": "Sistem gereksinimleri",
        "title": "İndirmeler",
        "type": "Tür",
        "updated": "İndirme güncellendi",
        "version": "Sürüm",
        "visibilityError": "Görünürlük değiştirilemedi",
        "visibilityUpdated": "Görünürlük güncellendi",
        "visible": "Görünür"
      }
    },
    "adminTickets": {
      "allAssigned": "Tüm atananlar",
      "allPriority": "Tüm öncelikler",
      "allStatus": "Tümü",
      "assigned": "Bilet size atandı",
      "assignedToMe": "Bana atananlar",
      "assignedToYou": "Size atandı",
      "assignee": "Atanan",
      "assignToMe": "Bana ata",
      "attachmentError": "Ek indirilemedi",
      "attachmentMissing": "Ek verisi mevcut değil",
      "declined": "Reddedildi",
      "detailError": "Bilet yüklenemedi",
      "high": "Yüksek",
      "inProcess": "İşlemde",
      "kicker": "Destek konsolu",
      "loadError": "Biletler yüklenemedi",
      "low": "Düşük",
      "normal": "Normal",
      "noTickets": "Bilet bulunamadı",
      "noTicketsDesc": "Filtreleri ayarlayın veya yeni destek taleplerini bekleyin.",
      "noUser": "Geçerli yönetici kullanıcısı yok",
      "open": "Açık",
      "priority": "Öncelik",
      "replyError": "Yanıt gönderilemedi",
      "replyPlaceholder": "Yanıtınızı yazın…",
      "search": "Bilet ara…",
      "selectTicket": "Bir bilet seçin",
      "selectTicketDesc": "Mesajları incelemek ve yanıtlamak için listeden bir konuşma seçin.",
      "solved": "Çözüldü",
      "status": "Durum",
      "subtitle": "Talepleri önceliklendirin, sahiplik atayın ve eklerle yanıtlayın.",
      "support": "Destek",
      "title": "Destek biletleri",
      "today": "Bugün",
      "unassigned": "Atanmamış",
      "updateError": "Bilet güncellenemedi",
      "urgent": "Acil"
    },
    "checkout": {
      "amount": "Tutar",
      "back": "Planlara dön",
      "cardName": "Kart üzerindeki ad",
      "cardNumber": "Kart numarası",
      "company": "Şirket",
      "email": "Fatura e-postası",
      "expiry": "Son kullanma",
      "kicker": "Güvenli ödeme",
      "loading": "Ödeme hazırlanıyor…",
      "paid": "Ödendi",
      "paidAt": "Ödeme zamanı",
      "paidKicker": "Ödeme tamamlandı",
      "paidTitle": "Yükseltmeniz tamam",
      "pay": "Öde",
      "paymentDetails": "Ödeme bilgileri",
      "plan": "Paket",
      "processing": "İşleniyor…",
      "status": "Durum",
      "summary": "Sipariş özeti",
      "title": "Ödemeyi tamamla",
      "toBilling": "Şirket faturalamasını gör",
      "toDashboard": "Panele dön",
      "totalDue": "Bugün ödenecek",
      "planNotFound": "Plan bulunamadı.",
      "paymentFailed": "Ödeme başarısız.",
      "demoNote": "Demo · Gerçek tahsilat yok",
      "paidLead": "{{plan}} planı etkinleştirildi. (Demo ödeme)",
      "demoLead": "Bu bir demo ödeme ekranıdır. Kart bilgileri gerçekten işlenmez; Öde deyince planınız yükseltilir ve fatura oluşur.",
      "loadPlanError": "Plan yüklenemedi.",
      "customPrice": "Özel fiyat",
      "loadFailed": "Ödeme sayfası yüklenemedi"
    },
    "common": {
      "back": "Yönetime dön",
      "cancel": "İptal",
      "close": "Kapat",
      "create": "Oluştur",
      "delete": "Sil",
      "downloading": "İndiriliyor…",
      "edit": "Düzenle",
      "loading": "Yükleniyor…",
      "ok": "Tamam",
      "refresh": "Yenile",
      "remove": "Kaldır",
      "save": "Değişiklikleri kaydet",
      "saving": "Kaydediliyor…",
      "sending": "Gönderiliyor…",
      "submitting": "Gönderiliyor…"
    },
    "company": {
      "cta": {
        "invite": "Ekip arkadaşı davet et",
        "upgrade": "Planları gör"
      },
      "invite": {
        "button": "Davet gönder",
        "createdNoEmail": "Davet oluşturuldu. Bu kodu paylaşın: {{code}}",
        "failed": "Davet gönderilemedi",
        "heading": "Ekip arkadaşı ekle",
        "help": "E-posta ile davet kodu göndeririz. Kayıt sırasında bu kodla katılabilirler.",
        "noSeat": "Koltuk yok",
        "oneSeat": "1 koltuk uygun",
        "placeholder": "ad@sirket.com",
        "seatsLeft": "{{left}} koltuk uygun",
        "sending": "Gönderiliyor…",
        "sent": "{{email}} adresine davet gönderildi",
        "title": "Davet"
      },
      "invites": {
        "acceptedNote": "{{count}} davet zaten kabul edildi.",
        "cancel": "İptal",
        "cancelFailed": "Davet iptal edilemedi",
        "cancelled": "Davet iptal edildi",
        "copied": "Davet kodu kopyalandı",
        "copiedShort": "Kopyalandı",
        "copy": "Kodu kopyala",
        "copyFailed": "Kod kopyalanamadı",
        "empty": "Bekleyen davet yok.",
        "pending": "Bekliyor",
        "sentOn": "{{date}} tarihinde gönderildi",
        "title": "Davetler"
      },
      "invoices": {
        "amount": "Tutar",
        "contact": "Satışa yazın",
        "date": "Tarih",
        "dueDate": "Vade",
        "empty": "Henüz fatura yok",
        "emptyDesc": "Faturalama başladığında faturalar burada görünür.",
        "history": "Fatura geçmişi",
        "plan": "Plan",
        "status": "Durum",
        "title": "Faturalama"
      },
      "kicker": "Şirket",
      "lead": "Koltukları, davetleri, plan limitlerini ve faturalamayı tek yerden yönetin.",
      "leadMobile": "Koltukları, davetleri ve faturalamayı yönetin.",
      "license": {
        "active": "Aktif",
        "expiresAt": "Bitiş",
        "inactive": "Pasif",
        "maxConnections": "Bağlantılar",
        "noExpiry": "Süresiz",
        "status": "Durum",
        "title": "Mevcut plan",
        "upgrade": "Planı yükselt"
      },
      "loadError": "Şirket bilgileri yüklenemedi",
      "loading": "Şirket yükleniyor…",
      "plan": {
        "connections": "bağlantı",
        "contact": "Bize ulaşın",
        "custom": "Özel",
        "unlimitedConnections": "Sınırsız bağlantı",
        "unlimitedUsers": "Sınırsız kullanıcı",
        "users": "kullanıcı"
      },
      "stats": {
        "connections": "Aktif bağlantılar",
        "pending": "Bekleyen davetler",
        "seats": "Koltuklar"
      },
      "tabs": {
        "billing": "Faturalama",
        "overview": "Genel bakış",
        "team": "Ekip"
      },
      "team": {
        "active": "Aktif",
        "admin": "Yönetici",
        "directory": "Dizin",
        "empty": "Henüz üye yüklenmedi.",
        "inactive": "Pasif",
        "joined": "Katılım",
        "manage": "Yönet",
        "member": "Üye",
        "members": "Üyeler",
        "none": "Aramanızla eşleşen üye yok.",
        "pendingNote": "Kabul bekleyen {{count}} davet var.",
        "role": "Rol",
        "search": "Üye ara…",
        "snapshot": "Ekip özeti",
        "status": "Durum",
        "user": "Kullanıcı"
      },
      "untitled": "Şirketiniz",
      "upgrade": {
        "current": "Mevcut plan",
        "heading": "Daha uygun bir plan seçin",
        "title": "Planlar",
        "demoNote": "Demo ödeme ile plan yükseltilir ve fatura oluşur."
      },
      "users": {
        "title": "Ekip koltukları"
      }
    },
    "connections": {
      "activeConnections": "Aktif",
      "activeNow": "Şu an aktif",
      "avgDuration": "Ort. süre",
      "companyConnections": "Şirket oturumları",
      "connectionsThisWeek": "Bu hafta",
      "connectionsToday": "Bugün",
      "disconnectConfirm": "Bu bağlantı oturumu sonlandırılsın mı?",
      "disconnected": "Bağlantı sonlandı",
      "disconnectError": "Bağlantı sonlandırılamadı",
      "ending": "Sonlandırılıyor…",
      "endSession": "Oturumu bitir",
      "filter": {
        "active": "Aktif",
        "all": "Tümü",
        "ended": "Biten"
      },
      "footer": "{{count}} oturum gösteriliyor",
      "kicker": "Oturumlar",
      "lead": "Hesabınızdaki canlı tünel etkinliği — kim bağlı, nerede ve ne kadar süredir.",
      "leadMobile": "Ayrıntılar için bir oturuma dokunun.",
      "liveSession": "Canlı oturum",
      "loading": "Oturumlar yükleniyor…",
      "mostUsedServer": "En çok kullanılan sunucu",
      "myConnections": "Oturumlarım",
      "noData": "Oturum bulunamadı",
      "noDataDesc": "Canlı tünel etkinliğini görmek için panelden bağlanın.",
      "pastSession": "Geçmiş oturum",
      "search": "Oturum ara…",
      "select": "Bir oturum seçin",
      "selectDesc": "Rota, süre ve aktarımı incelemek için soldan bir tünel seçin.",
      "signalEnded": "Bu tünel kapalı. Geçmiş aktarım toplamları hâlâ görülebilir.",
      "signalLive": "Şifreli tünel aktif. Metrikler her 15 saniyede yenilenir.",
      "status": {
        "active": "Canlı",
        "disconnected": "Bitti"
      },
      "table": {
        "data": "Aktarılan",
        "duration": "Süre",
        "ipAddress": "İstemci IP",
        "startTime": "Başlangıç",
        "status": "Durum",
        "user": "Kullanıcı"
      },
      "title": "Bağlantılar",
      "totalData": "Toplam veri",
      "uniqueUsersToday": "Bugünkü kullanıcılar",
      "upDown": "Yukarı / Aşağı"
    },
    "dashboard": {
      "actions": {
        "clients": "İstemcileri al",
        "sessions": "Oturumları gör"
      },
      "disconnect": "Oturumu bitir",
      "disconnectFailed": "Bağlantı kesilemedi",
      "ending": "Sonlandırılıyor…",
      "greeting": {
        "afternoon": "İyi öğleden sonralar",
        "evening": "İyi akşamlar",
        "morning": "Günaydın",
        "night": "İyi geceler"
      },
      "kicker": "Operasyon",
      "lead": "Güvenli ağınıza genel bakış — canlı tüneller, bölgeler ve son oturumlar.",
      "leadMobile": "Bağlanmak için aşağıdan bir bölge seçin.",
      "live": {
        "choose": "Bağlanmak için bir bölge seçin",
        "idle": "Boşta",
        "protected": "Korumalı"
      },
      "quick": {
        "clients": "İstemci uygulamaları",
        "get": "Al",
        "notifications": "Okunmamış uyarılar",
        "recent": "Son oturumlar",
        "tickets": "Açık biletler"
      },
      "recent": {
        "all": "Tümü",
        "empty": "Henüz oturum yok",
        "emptyDesc": "İlk tünelinizi başlatmak için bir bölgeye bağlanın.",
        "kicker": "Geçmiş",
        "title": "Son oturumlar"
      },
      "regions": {
        "count": "bölge",
        "empty": "Henüz bölge yayınlanmadı",
        "emptyDesc": "Onaylı sunucular burada görünür.",
        "kicker": "Ağ",
        "load": "yük",
        "noServers": "Bu bölgede sunucu yok.",
        "online": "çevrimiçi",
        "title": "Küresel bölgeler",
        "unknown": "Bilinmiyor",
        "upgrade": "Yükselt"
      },
      "stats": {
        "connections": "Aktif",
        "connectionTime": "Çevrimiçi süre",
        "data": "Kullanılan veri",
        "servers": "Sunucular",
        "today": "Bugünkü oturumlar"
      },
      "status": {
        "ended": "Bitti",
        "live": "Canlı"
      },
      "tunnel": {
        "duration": "Süre",
        "live": "Canlı tünel",
        "started": "Başladı",
        "transfer": "Aktarım"
      },
      "upgrade": "Yükselt",
      "upgradeAskAdmin": "Paketi yükseltmek için şirket yönetim izni gerekir.",
      "verification": {
        "button": "Şimdi doğrula",
        "kicker": "Doğrula",
        "message": "Güvenli bağlantıları açmak için e-postanızı doğrulayın.",
        "title": "E-postanızı onaylayın"
      }
    },
    "downloads": {
      "arch": "Mimari",
      "changelog": "Sürüm notları",
      "channel": "Kanal",
      "client": "İstemci",
      "defaultDesc": "Kuruluşunuz için güvenli ArcVPN istemcisi.",
      "download": "İndir",
      "features": "İstemci özellikleri",
      "filter": {
        "all": "Tümü",
        "desktop": "Masaüstü",
        "mobile": "Mobil"
      },
      "install": "Kur",
      "kicker": "İstemciler",
      "latest": "Son sürüm",
      "leadMobile": "Bir platform seçin, ardından indirin.",
      "minOs": "Minimum işletim sistemi",
      "noDownloads": "Henüz indirme yok",
      "noDownloadsDesc": "Lütfen kısa süre sonra tekrar kontrol edin.",
      "noReqs": "Henüz ayrıntılı gereksinim yayınlanmadı.",
      "openStore": "Mağazayı aç",
      "platforms": "Platformlar",
      "reqHint": "Bu istemci için donanım ve OS tabanı.",
      "requirements": "Sistem gereksinimleri",
      "size": "Boyut",
      "subtitle": "Ekibinizin kullandığı her platform için net gereksinimler ve sürüm ayrıntılarıyla uygulamalar.",
      "title": "ArcVPN istemcileri",
      "type": {
        "link": "Doğrudan bağlantı",
        "store": "Mağaza"
      },
      "unavailable": {
        "message": "Bu derleme henüz yayınlanmadı. Lütfen kısa süre sonra tekrar deneyin.",
        "title": "İstemci güncelleniyor"
      },
      "updated": "Güncellendi",
      "version": "Sürüm"
    },
    "errors": {
      "sessionExpired": "Oturum süresi doldu. Lütfen tekrar giriş yapın."
    },
    "notifications": {
      "allCaughtUp": "Hepsi okundu",
      "allMarked": "Tüm bildirimler okundu olarak işaretlendi",
      "daysAgo": "{{count}}g önce",
      "delete": "Sil",
      "deleteError": "Bildirim silinemedi",
      "empty": "Henüz bildirim yok",
      "emptyDesc": "Yeni etkinlikler burada otomatik görünür.",
      "filter": {
        "all": "Tümü",
        "read": "Okunan",
        "unread": "Okunmayan"
      },
      "hoursAgo": "{{count}}sa önce",
      "justNow": "Az önce",
      "kicker": "Gelen kutusu",
      "lead": "Bağlantı olayları, destek güncellemeleri ve sistem mesajları tek yerde.",
      "loadError": "Bildirimler yüklenemedi",
      "markAll": "Tümünü okundu yap",
      "markError": "Bildirimler okundu işaretlenemedi",
      "markRead": "Okundu yap",
      "minsAgo": "{{count}}dk önce",
      "showing": "Gösterilen",
      "title": "Bildirimler",
      "total": "Toplam",
      "unread": "{{count}} okunmamış",
      "unreadLabel": "Okunmamış",
      "viewAll": "Tüm bildirimleri gör"
    },
    "pricing": {
      "contactBtn": "Satışa yazın",
      "contactUs": "Bize ulaşın",
      "freeBtn": "Ücretsiz başla",
      "month": "ay",
      "plans": {
        "enterprise": {
          "name": "Kurumsal"
        },
        "free": {
          "description": "Ücretsiz başlayın",
          "feature1": "1 Kullanıcı",
          "feature2": "1 Bağlantı",
          "feature3": "Temel Destek",
          "name": "Ücretsiz"
        },
        "professional": {
          "name": "Profesyonel"
        },
        "starter": {
          "name": "Başlangıç"
        }
      },
      "popular": "En Popüler",
      "startBtn": "Hemen başla"
    },
    "profile": {
      "fields": {
        "company": "Şirket",
        "email": "E-posta",
        "license": "Lisans",
        "memberSince": "Üyelik tarihi",
        "role": "Rol",
        "username": "Kullanıcı adı"
      },
      "kicker": "Hesap",
      "leadMobile": "Hesap bilgileriniz ve güvenlik.",
      "password": {
        "confirm": "Yeni şifre (tekrar)",
        "current": "Mevcut şifre",
        "errors": {
          "allFieldsRequired": "Tüm alanlar zorunludur",
          "failed": "Şifre değiştirilemedi",
          "passwordsDontMatch": "Yeni şifreler eşleşmiyor",
          "passwordTooShort": "Şifre en az 6 karakter olmalı"
        },
        "new": "Yeni şifre",
        "save": "Şifreyi değiştir",
        "success": "Şifre başarıyla değiştirildi",
        "title": "Şifre değiştir"
      },
      "roles": {
        "companyAdmin": "Şirket yöneticisi",
        "systemAdmin": "Sistem yöneticisi",
        "user": "Kullanıcı"
      },
      "security": {
        "changePassword": "Şifre değiştir",
        "password": "Şifre",
        "passwordHint": "Hesabınızı güvende tutmak için şifrenizi değiştirin",
        "title": "Güvenlik"
      },
      "subtitle": "Hesap ayarlarınızı yönetin",
      "title": "Profil",
      "unverified": "Doğrulanmadı",
      "verified": "Doğrulandı"
    },
    "sidebar": {
      "admin": "Sistem yönetimi",
      "company": "Şirketim",
      "connections": "Bağlantılar",
      "dashboard": "Panel",
      "downloads": "İndirmeler",
      "logout": "Çıkış yap",
      "logoutConfirm": "Çıkış yapmak istediğinize emin misiniz?",
      "logoutConfirmTitle": "Çıkış yapılsın mı?",
      "mobileNav": "Ana menü",
      "more": "Daha fazla",
      "premiumPackage": "Şirket premium paketi",
      "profile": "Profil",
      "short": {
        "admin": "Yönetim",
        "apps": "Uygulamalar",
        "company": "Şirket",
        "help": "Yardım",
        "home": "Ana",
        "links": "Bağlantılar"
      },
      "tickets": "Destek",
      "upgradeCta": "Yükselt",
      "viewPlanCta": "Paketi gör"
    },
    "systemAdmin": {
      "back": "Geri",
      "companies": {
        "deleteFailed": "Şirket silinemedi",
        "deleteSuccess": "Şirket başarıyla silindi",
        "licenseUpdateFailed": "Lisans güncellenemedi",
        "licenseUpdateSuccess": "Lisans başarıyla güncellendi",
        "loadDetailsFailed": "Şirket ayrıntıları yüklenemedi",
        "updateFailed": "Şirket güncellenemedi",
        "updateSuccess": "Şirket başarıyla güncellendi"
      },
      "endpoints": {
        "col": {
          "agent": "Ajan",
          "heartbeat": "Son heartbeat",
          "load": "Yük",
          "location": "Konum",
          "node": "Düğüm",
          "status": "Durum"
        },
        "empty": "Henüz uç nokta yok",
        "emptyLead": "Kayıt anahtarı oluşturup bir ajan ekleyerek düğümleri burada görün.",
        "lead": "Websocket + heartbeat ile gerçek ajan durumu — eski DB bayrakları değil.",
        "loading": "Uç noktalar yükleniyor…",
        "open": "Sunucuları aç",
        "title": "Uç noktalar"
      },
      "kicker": "Kontrol düzlemi",
      "leadMobile": "Platform sağlığı ve yönetim modülleri.",
      "menuLabel": "Yönetim modülleri",
      "open": "Aç",
      "openLogs": "Logları gör",
      "openServers": "Sunucuları yönet",
      "servers": {
        "addServer": "Sunucu dağıt",
        "agentStatus": {
          "connected": "Bağlı",
          "disconnected": "Bağlı değil",
          "pending": "Bekliyor"
        },
        "card": {
          "approve": "Onayla",
          "load": "Yük",
          "reject": "Reddet",
          "settings": "Ayarlar",
          "users": "Kullanıcılar"
        },
        "deleteError": "Sunucu silinirken bir hata oluştu",
        "deleteSuccess": "Sunucu başarıyla silindi!",
        "editBeforeApprove": "Onaydan önce yapılandır",
        "editPending": {
          "approveBtn": "Onayla ve kaydet",
          "location": "Konum",
          "name": "Sunucu adı",
          "selectLocation": "Bir konum seçin",
          "visibilityNote": "Onay sonrası sunucu kullanıcılardan gizlenir. Daha sonra görünür yapabilirsiniz."
        },
        "empty": {
          "description": "Burada ajan kaydetmek için SSH üzerinden sunucu dağıtın.",
          "title": "Henüz sunucu yok"
        },
        "filter": {
          "all": "Tümü",
          "label": "Ülke"
        },
        "keyCreateError": "Kayıt anahtarı oluşturulurken hata oluştu",
        "keyCreateSuccess": "Yeni kayıt anahtarı oluşturuldu!",
        "keyRevokeError": "Anahtar iptal edilirken hata oluştu",
        "keyRevokeSuccess": "Anahtar başarıyla iptal edildi!",
        "loading": "Sunucular yükleniyor…",
        "locationCreateSuccess": "Konum başarıyla oluşturuldu!",
        "locationDeleteError": "Konum silinirken hata oluştu",
        "locationDeleteSuccess": "Konum başarıyla silindi!",
        "locationSaveError": "Konum kaydedilirken hata oluştu",
        "locationUpdateSuccess": "Konum başarıyla güncellendi!",
        "pendingModal": {
          "approve": "Onayla",
          "noPending": "Bekleyen sunucu yok",
          "reject": "Reddet",
          "title": "Bekleyen sunucular"
        },
        "retry": "Tekrar dene",
        "saveError": "Ayarlar kaydedilirken bir hata oluştu",
        "stats": {
          "activeUsers": "Aktif kullanıcılar",
          "avgLoad": "Ort. yük",
          "onlineServers": "Çevrimiçi",
          "totalServers": "Toplam"
        },
        "status": {
          "maintenance": "Bakım",
          "offline": "Çevrimdışı",
          "online": "Çevrimiçi"
        },
        "subtitle": "SSH ile kenar dağıtın, düğümleri onaylayın, isteğe bağlı failover ayarlayın, kayıt anahtarlarını yönetin.",
        "title": "Sunucular",
        "toggleError": "Sunucu durumu değiştirilirken bir hata oluştu",
        "visibilityError": "Görünürlük değiştirilemedi",
        "visibilityToggled": "Sunucu görünürlüğü güncellendi"
      },
      "stats": {
        "companies": "Şirketler",
        "connections": "Aktif tüneller",
        "errors": "Hatalar 24s",
        "liveAgents": "Canlı ajanlar",
        "openTickets": "Açık biletler",
        "servers": "Çevrimiçi sunucular",
        "users": "Kullanıcılar",
        "visible": "Görünür düğümler"
      },
      "statsError": "Canlı metrikler yüklenemedi",
      "subtitle": "Canlı platform sağlığı — kullanıcılar, ajanlar, uç noktalar ve operasyon sinyalleri.",
      "title": "Sistem yönetimi"
    },
    "tickets": {
      "active": "Aktif",
      "allTickets": "Tümü",
      "attach": "Ekle",
      "attachment": "Ek",
      "category": "Kategori",
      "chooseFile": "Dosya seçin",
      "closedNotice": "Bu bilet kapalı. Hâlâ yardıma ihtiyacınız varsa yeni bilet açın.",
      "created": "Bilet başarıyla oluşturuldu! Bilet #{{number}}",
      "createFirst": "İlk biletinizi oluşturun",
      "createTicket": "Bilet oluştur",
      "createTicketTitle": "Ne olduğunu anlatın",
      "emailShort": "E-posta",
      "fileTooLarge": "Dosya çok büyük. Maksimum boyut 2MB",
      "fillRequired": "Lütfen konu ve mesajı doldurun",
      "heroLead": "Bağlantı, hesap veya faturalama sorunları için bilet açın. Ekibimiz bu iş parçacığında yanıtlar.",
      "heroTitle": "Nasıl yardımcı olabiliriz?",
      "inProcess": "İşlemde",
      "kicker": "Destek",
      "leadMobile": "Bilet açın veya devam etmek için aşağıdan birini seçin.",
      "loading": "Biletler yükleniyor…",
      "message": "Mesaj",
      "messagePlaceholder": "Sorununuzu ayrıntılı anlatın…",
      "messages": "mesaj",
      "messageSent": "Mesaj gönderildi",
      "newTicket": "Yeni bilet",
      "noTickets": "Henüz bilet yok",
      "noTicketsDesc": "Bilet oluşturun, bu gelen kutusundan takip edelim.",
      "open": "Açık",
      "priority": "Öncelik",
      "priorityHigh": "Yüksek",
      "priorityLow": "Düşük",
      "priorityNormal": "Normal",
      "priorityUpdated": "Öncelik güncellendi",
      "priorityUrgent": "Acil",
      "replyPlaceholder": "Yanıt yazın…",
      "search": "Bilet ara…",
      "selectCategory": "Kategori seçin",
      "selectTicket": "Bir bilet seçin",
      "selectTicketDesc": "Soldan bir konuşma seçin veya yeni talep açın.",
      "send": "Gönder",
      "solved": "Çözüldü",
      "statusUpdated": "Durum güncellendi",
      "subject": "Konu",
      "subjectPlaceholder": "Sorununuzun kısa açıklaması",
      "submit": "Bileti gönder",
      "supportTeam": "Destek",
      "total": "Toplam",
      "declined": "Reddedildi",
      "topicConnectTitle": "Bağlantı sorunu",
      "topicConnectHint": "VPN bağlantısı kurulamıyor veya kopuyor",
      "topicConnectSubject": "Bağlantı sorunu",
      "topicAccountTitle": "Hesap & erişim",
      "topicAccountHint": "Kullanıcı, davet veya giriş sorunları",
      "topicAccountSubject": "Hesap ve erişim",
      "topicBillingTitle": "Plan & fatura",
      "topicBillingHint": "Lisans, fatura veya plan yükseltme",
      "topicBillingSubject": "Plan ve fatura",
      "justNow": "az önce",
      "minsAgo": "{{n}} dk",
      "hoursAgo": "{{n}} sa",
      "daysAgo": "{{n}} g",
      "detailsLabel": "Detaylar:"
    },
    "upgrade": {
      "buy": "Satın al ve yükselt",
      "current": "Mevcut plan",
      "kicker": "Şirket paketi",
      "leadAdmin": "Bir plan seçin, demo ödemeyi tamamlayın; şirketiniz fatura ile anında yükseltilir.",
      "leadMember": "Bu paketi yalnızca şirket yönetim izni olan kullanıcı yükseltebilir.",
      "loading": "Plan yükleniyor…",
      "lockedBody": "Şirket paketini değiştirmek için şirket yönetim izni gerekir. Yükseltme için yöneticinize sorun.",
      "lockedTitle": "Yükseltme kullanılamıyor",
      "plans": {
        "basic": "Temel",
        "enterprise": "Kurumsal",
        "free": "Ücretsiz",
        "pro": "Pro"
      },
      "title": "Premium paket",
      "leadAdminShort": "Plan seç → demo ödeme → anında yükselt.",
      "leadMemberShort": "Yalnızca şirket yöneticisi yükseltebilir.",
      "demoNote": "Demo ödeme: kart bilgileri işlenmez. Ödeme sonrası fatura oluşur ve plan hemen aktif olur."
    },
    "connectModal": {
      "serverFallback": "sunucu",
      "titleConnect": "Bağlan · {{location}}",
      "titleConnected": "Bağlandı · {{location}}",
      "kickerReady": "Tünel hazır",
      "kickerSecure": "Güvenli tünel",
      "close": "Kapat",
      "load": "Yük",
      "protocol": "Protokol",
      "configReady": "Yapılandırma hazır",
      "waiting": "Bekleniyor",
      "leadBefore": "Bu uç nokta için tek kullanımlık WireGuard yapılandırması oluşturun. Mobilde QR tarayın veya masaüstünde dosyayı içe aktarın.",
      "step1": "Şifreli peer anahtarları sunucu tarafında oluşturulur",
      "step2": "Yapılandırma DNS ve uç nokta yönlendirmesini içerir",
      "step3": "Bir kez içe aktarın — tüneli WireGuard’da açın",
      "leadAfter": "VPN profiliniz hazır. WireGuard uygulamasıyla tarayın veya yapılandırma dosyasını indirin.",
      "tabQr": "QR kod",
      "tabConfig": "Yapılandırma metni",
      "scanHint": "WireGuard’ı açın → QR kodu tarayın",
      "copied": "Kopyalandı",
      "copyConfig": "Yapılandırmayı kopyala",
      "vpnIp": "VPN IP",
      "server": "Sunucu",
      "dns": "DNS",
      "cancel": "İptal",
      "connecting": "Bağlanıyor…",
      "connect": "Bağlan",
      "downloadConf": ".conf indir",
      "done": "Tamam",
      "connectFailed": "Bağlantı başarısız"
    },
    "careers": {
      "title": "Kariyer",
      "subtitle": "Ürünü sade tutan, operasyonu ciddiye alan insanlarla büyüyoruz.",
      "whyTitle": "Neden ArcVPN?",
      "whyFocusTitle": "Odak",
      "whyFocusBody": "Gerçek müşteri sorunlarına yakın çalışırsınız; gürültülü roadmap yok.",
      "whyOwnershipTitle": "Sahiplik",
      "whyOwnershipBody": "Küçük ekipler, net sorumluluklar, görünen etki.",
      "whyFlexibilityTitle": "Esneklik",
      "whyFlexibilityBody": "Hibrit çalışma ve sonuç odaklı tempo.",
      "whyLearningTitle": "Öğrenme",
      "whyLearningBody": "Güvenlik, ağ ve ürün disiplinlerinde yan yana büyüme.",
      "openTitle": "Açık pozisyonlar",
      "emptyTitle": "Şu an açık pozisyonumuz yok",
      "emptyBody": "İlgini çeken bir rol için CV’ni veya LinkedIn profilini mail at. Uygun bir açılış olduğunda seninle iletişime geçeriz.",
      "cta": "Mail gönder",
      "email": "info@arcyintel.com",
      "mailSubject": "ArcVPN basvuru"
    }
  },
  fr: {
    "admin": {
      "downloads": {
        "add": "Ajouter une plateforme",
        "architectures": "Architectures",
        "count": "Téléchargements",
        "created": "Téléchargement créé",
        "createTitle": "Ajouter une plateforme",
        "deleteConfirm": "Supprimer cette plateforme de téléchargement ?",
        "deleted": "Téléchargement supprimé",
        "deleteError": "Échec de la suppression",
        "editTitle": "Modifier la plateforme",
        "emptyDesc": "Ajoutez une build client à publier sur la page des téléchargements.",
        "emptyTitle": "Aucune plateforme",
        "hidden": "Masqué",
        "hide": "Masquer",
        "invalidJson": "Les exigences système doivent être un JSON valide",
        "kicker": "Builds client",
        "loadError": "Échec du chargement des téléchargements",
        "order": "Ordre",
        "requirements": "Exigences",
        "saveError": "Échec de l’enregistrement",
        "show": "Afficher",
        "size": "Taille",
        "stats": {
          "count": "Téléchargements totaux",
          "hidden": "Masqués",
          "total": "Plateformes",
          "visible": "Visibles"
        },
        "subtitle": "Publiez builds, exigences, checksums et notes de version.",
        "systemReq": "Exigences système",
        "title": "Téléchargements",
        "type": "Type",
        "updated": "Téléchargement mis à jour",
        "version": "Version",
        "visibilityError": "Impossible de modifier la visibilité",
        "visibilityUpdated": "Visibilité mise à jour",
        "visible": "Visible"
      }
    },
    "adminTickets": {
      "allAssigned": "Tous les assignés",
      "allPriority": "Toutes priorités",
      "allStatus": "Tous",
      "assigned": "Ticket qui vous est assigné",
      "assignedToMe": "Assignés à moi",
      "assignedToYou": "Assigné à vous",
      "assignee": "Assigné",
      "assignToMe": "M’assigner",
      "attachmentError": "Échec du téléchargement de la pièce jointe",
      "attachmentMissing": "Données de pièce jointe indisponibles",
      "declined": "Refusé",
      "detailError": "Échec du chargement du ticket",
      "high": "Élevée",
      "inProcess": "En cours",
      "kicker": "Console support",
      "loadError": "Échec du chargement des tickets",
      "low": "Basse",
      "normal": "Normale",
      "noTickets": "Aucun ticket trouvé",
      "noTicketsDesc": "Ajustez les filtres ou attendez de nouvelles demandes.",
      "noUser": "Utilisateur admin actuel indisponible",
      "open": "Ouvert",
      "priority": "Priorité",
      "replyError": "Échec de l’envoi de la réponse",
      "replyPlaceholder": "Saisissez votre réponse…",
      "search": "Rechercher des tickets…",
      "selectTicket": "Sélectionnez un ticket",
      "selectTicketDesc": "Choisissez une conversation pour examiner les messages et répondre.",
      "solved": "Résolu",
      "status": "Statut",
      "subtitle": "Triez les demandes, assignez et répondez avec pièces jointes.",
      "support": "Support",
      "title": "Tickets support",
      "today": "Aujourd’hui",
      "unassigned": "Non assigné",
      "updateError": "Échec de la mise à jour du ticket",
      "urgent": "Urgent"
    },
    "checkout": {
      "amount": "Montant",
      "back": "Retour aux plans",
      "cardName": "Nom sur la carte",
      "cardNumber": "Numéro de carte",
      "company": "Entreprise",
      "email": "E-mail de facturation",
      "expiry": "Expiration",
      "kicker": "Paiement sécurisé",
      "loading": "Préparation du paiement…",
      "paid": "Payé",
      "paidAt": "Payé le",
      "paidKicker": "Paiement terminé",
      "paidTitle": "Vous êtes passé à un plan supérieur",
      "pay": "Payer",
      "paymentDetails": "Détails du paiement",
      "plan": "Offre",
      "processing": "Traitement…",
      "status": "Statut",
      "summary": "Récapitulatif",
      "title": "Finaliser le paiement",
      "toBilling": "Voir la facturation",
      "toDashboard": "Retour au tableau de bord",
      "totalDue": "Total dû aujourd’hui",
      "planNotFound": "Plan introuvable.",
      "paymentFailed": "Échec du paiement.",
      "demoNote": "Démo · Aucun débit réel",
      "paidLead": "{{plan}} est maintenant actif. (Paiement démo)",
      "demoLead": "Ceci est un écran de paiement démo. Les détails de carte ne sont pas traités ; Payer améliore votre plan et crée une facture.",
      "loadPlanError": "Impossible de charger le plan.",
      "customPrice": "Prix personnalisé",
      "loadFailed": "Échec du chargement du paiement"
    },
    "common": {
      "back": "Retour à l’admin",
      "cancel": "Annuler",
      "close": "Fermer",
      "create": "Créer",
      "delete": "Supprimer",
      "downloading": "Téléchargement…",
      "edit": "Modifier",
      "loading": "Chargement…",
      "ok": "OK",
      "refresh": "Actualiser",
      "remove": "Retirer",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "sending": "Envoi…",
      "submitting": "Envoi…"
    },
    "company": {
      "cta": {
        "invite": "Inviter un collègue",
        "upgrade": "Voir les plans"
      },
      "invite": {
        "button": "Envoyer l’invitation",
        "createdNoEmail": "Invitation créée. Partagez ce code : {{code}}",
        "failed": "Échec de l’envoi de l’invitation",
        "heading": "Ajouter un collègue",
        "help": "Nous envoyons un code par e-mail. Ils peuvent rejoindre à l’inscription avec ce code.",
        "noSeat": "Aucun siège",
        "oneSeat": "1 siège disponible",
        "placeholder": "nom@entreprise.com",
        "seatsLeft": "{{left}} sièges disponibles",
        "sending": "Envoi…",
        "sent": "Invitation envoyée à {{email}}",
        "title": "Invitation"
      },
      "invites": {
        "acceptedNote": "{{count}} invitation(s) déjà acceptée(s).",
        "cancel": "Annuler",
        "cancelFailed": "Échec de l’annulation",
        "cancelled": "Invitation annulée",
        "copied": "Code d’invitation copié",
        "copiedShort": "Copié",
        "copy": "Copier le code",
        "copyFailed": "Impossible de copier le code",
        "empty": "Aucune invitation en attente.",
        "pending": "En attente",
        "sentOn": "Envoyée le {{date}}",
        "title": "Invitations"
      },
      "invoices": {
        "amount": "Montant",
        "contact": "Contacter les ventes",
        "date": "Date",
        "dueDate": "Échéance",
        "empty": "Aucune facture",
        "emptyDesc": "Lorsque la facturation démarre, les factures apparaissent ici.",
        "history": "Historique des factures",
        "plan": "Plan",
        "status": "Statut",
        "title": "Facturation"
      },
      "kicker": "Entreprise",
      "lead": "Gérez sièges, invitations, limites de plan et facturation au même endroit.",
      "leadMobile": "Gérez sièges, invitations et facturation.",
      "license": {
        "active": "Actif",
        "expiresAt": "Expire",
        "inactive": "Inactif",
        "maxConnections": "Connexions",
        "noExpiry": "Sans expiration",
        "status": "Statut",
        "title": "Plan actuel",
        "upgrade": "Améliorer le plan"
      },
      "loadError": "Échec du chargement des infos entreprise",
      "loading": "Chargement de l’entreprise…",
      "plan": {
        "connections": "connexions",
        "contact": "Nous contacter",
        "custom": "Personnalisé",
        "unlimitedConnections": "Connexions illimitées",
        "unlimitedUsers": "Utilisateurs illimités",
        "users": "utilisateurs"
      },
      "stats": {
        "connections": "Liens actifs",
        "pending": "Invitations en attente",
        "seats": "Sièges"
      },
      "tabs": {
        "billing": "Facturation",
        "overview": "Aperçu",
        "team": "Équipe"
      },
      "team": {
        "active": "Actif",
        "admin": "Admin",
        "directory": "Annuaire",
        "empty": "Aucun membre chargé.",
        "inactive": "Inactif",
        "joined": "Inscrit",
        "manage": "Gérer",
        "member": "Membre",
        "members": "Membres",
        "none": "Aucun membre ne correspond à votre recherche.",
        "pendingNote": "{{count}} invitation(s) en attente d’acceptation.",
        "role": "Rôle",
        "search": "Rechercher des membres…",
        "snapshot": "Aperçu de l’équipe",
        "status": "Statut",
        "user": "Utilisateur"
      },
      "untitled": "Votre entreprise",
      "upgrade": {
        "current": "Plan actuel",
        "heading": "Choisissez une meilleure offre",
        "title": "Plans",
        "demoNote": "Le paiement démo améliore le plan et crée une facture."
      },
      "users": {
        "title": "Sièges d’équipe"
      }
    },
    "connections": {
      "activeConnections": "Actives",
      "activeNow": "Actives maintenant",
      "avgDuration": "Durée moy.",
      "companyConnections": "Sessions entreprise",
      "connectionsThisWeek": "Cette semaine",
      "connectionsToday": "Aujourd’hui",
      "disconnectConfirm": "Terminer cette session de connexion ?",
      "disconnected": "Connexion terminée",
      "disconnectError": "Impossible de terminer la connexion",
      "ending": "Fin…",
      "endSession": "Terminer la session",
      "filter": {
        "active": "Actives",
        "all": "Toutes",
        "ended": "Terminées"
      },
      "footer": "{{count}} sessions affichées",
      "kicker": "Sessions",
      "lead": "Activité tunnel en direct — qui est connecté, où, et depuis combien de temps.",
      "leadMobile": "Touchez une session pour les détails.",
      "liveSession": "Session en direct",
      "loading": "Chargement des sessions…",
      "mostUsedServer": "Serveur principal",
      "myConnections": "Mes sessions",
      "noData": "Aucune session trouvée",
      "noDataDesc": "Connectez-vous depuis le tableau de bord pour voir l’activité ici.",
      "pastSession": "Session passée",
      "search": "Rechercher des sessions…",
      "select": "Sélectionnez une session",
      "selectDesc": "Choisissez un tunnel à gauche pour inspecter route, durée et transfert.",
      "signalEnded": "Ce tunnel est fermé. Les totaux de transfert historiques restent disponibles.",
      "signalLive": "Tunnel chiffré actif. Métriques actualisées toutes les 15 secondes.",
      "status": {
        "active": "En direct",
        "disconnected": "Terminée"
      },
      "table": {
        "data": "Transféré",
        "duration": "Durée",
        "ipAddress": "IP client",
        "startTime": "Démarré",
        "status": "Statut",
        "user": "Utilisateur"
      },
      "title": "Connexions",
      "totalData": "Données totales",
      "uniqueUsersToday": "Utilisateurs aujourd’hui",
      "upDown": "Montant / Descendant"
    },
    "dashboard": {
      "actions": {
        "clients": "Obtenir les clients",
        "sessions": "Voir les sessions"
      },
      "disconnect": "Terminer la session",
      "disconnectFailed": "Échec de la déconnexion",
      "ending": "Fin…",
      "greeting": {
        "afternoon": "Bon après-midi",
        "evening": "Bonsoir",
        "morning": "Bonjour",
        "night": "Bonne nuit"
      },
      "kicker": "Opérations",
      "lead": "Votre réseau sécurisé en un coup d’œil — tunnels, régions et sessions récentes.",
      "leadMobile": "Choisissez une région ci-dessous pour vous connecter.",
      "live": {
        "choose": "Choisissez une région pour vous connecter",
        "idle": "Inactif",
        "protected": "Protégé"
      },
      "quick": {
        "clients": "Applications client",
        "get": "Obtenir",
        "notifications": "Alertes non lues",
        "recent": "Sessions récentes",
        "tickets": "Tickets ouverts"
      },
      "recent": {
        "all": "Toutes",
        "empty": "Aucune session",
        "emptyDesc": "Connectez-vous à une région pour démarrer votre premier tunnel.",
        "kicker": "Historique",
        "title": "Sessions récentes"
      },
      "regions": {
        "count": "régions",
        "empty": "Aucune région publiée",
        "emptyDesc": "Les serveurs approuvés apparaîtront ici.",
        "kicker": "Réseau",
        "load": "charge",
        "noServers": "Aucun serveur dans cette région.",
        "online": "en ligne",
        "title": "Régions mondiales",
        "unknown": "Inconnu",
        "upgrade": "Améliorer"
      },
      "stats": {
        "connections": "Actives",
        "connectionTime": "Temps en ligne",
        "data": "Données utilisées",
        "servers": "Serveurs",
        "today": "Sessions aujourd’hui"
      },
      "status": {
        "ended": "Terminée",
        "live": "En direct"
      },
      "tunnel": {
        "duration": "Durée",
        "live": "Tunnel en direct",
        "started": "Démarré",
        "transfer": "Transfert"
      },
      "upgrade": "Améliorer",
      "upgradeAskAdmin": "Une personne avec permission de gestion entreprise peut améliorer le forfait.",
      "verification": {
        "button": "Vérifier maintenant",
        "kicker": "Vérifier",
        "message": "Vérifiez votre e-mail pour débloquer les connexions sécurisées.",
        "title": "Confirmez votre e-mail"
      }
    },
    "downloads": {
      "arch": "Architectures",
      "changelog": "Notes de version",
      "channel": "Canal",
      "client": "Client",
      "defaultDesc": "Client ArcVPN sécurisé pour votre organisation.",
      "download": "Télécharger",
      "features": "Fonctionnalités client",
      "filter": {
        "all": "Tous",
        "desktop": "Bureau",
        "mobile": "Mobile"
      },
      "install": "Installer",
      "kicker": "Clients",
      "latest": "Dernière ligne",
      "leadMobile": "Choisissez une plateforme, puis téléchargez.",
      "minOs": "Système minimum",
      "noDownloads": "Aucun téléchargement disponible",
      "noDownloadsDesc": "Veuillez réessayer sous peu.",
      "noReqs": "Aucune exigence détaillée publiée.",
      "openStore": "Ouvrir le store",
      "platforms": "Plateformes",
      "reqHint": "Base matérielle et OS pour ce client.",
      "requirements": "Exigences système",
      "size": "Taille",
      "subtitle": "Applications soignées pour chaque plateforme — avec exigences et détails de version clairs.",
      "title": "Clients ArcVPN",
      "type": {
        "link": "Lien direct",
        "store": "Boutique"
      },
      "unavailable": {
        "message": "Cette build n’est pas encore publiée. Réessayez sous peu.",
        "title": "Client en mise à jour"
      },
      "updated": "Mis à jour",
      "version": "Version"
    },
    "errors": {
      "sessionExpired": "Session expirée. Veuillez vous reconnecter."
    },
    "notifications": {
      "allCaughtUp": "Vous êtes à jour",
      "allMarked": "Toutes les notifications marquées comme lues",
      "daysAgo": "il y a {{count}}j",
      "delete": "Supprimer",
      "deleteError": "Impossible de supprimer la notification",
      "empty": "Aucune notification",
      "emptyDesc": "La nouvelle activité apparaîtra ici automatiquement.",
      "filter": {
        "all": "Toutes",
        "read": "Lues",
        "unread": "Non lues"
      },
      "hoursAgo": "il y a {{count}}h",
      "justNow": "À l’instant",
      "kicker": "Boîte de réception",
      "lead": "Événements de connexion, mises à jour support et messages système au même endroit.",
      "loadError": "Impossible de charger les notifications",
      "markAll": "Tout marquer lu",
      "markError": "Impossible de marquer comme lu",
      "markRead": "Marquer lu",
      "minsAgo": "il y a {{count}}m",
      "showing": "Affichage",
      "title": "Notifications",
      "total": "Total",
      "unread": "{{count}} non lues",
      "unreadLabel": "Non lues",
      "viewAll": "Voir toutes les notifications"
    },
    "pricing": {
      "contactBtn": "Contacter les ventes",
      "contactUs": "Nous contacter",
      "freeBtn": "Commencer gratuitement",
      "month": "mois",
      "plans": {
        "enterprise": {
          "name": "Entreprise"
        },
        "free": {
          "description": "Commencez gratuitement",
          "feature1": "1 utilisateur",
          "feature2": "1 connexion",
          "feature3": "Support de base",
          "name": "Gratuit"
        },
        "professional": {
          "name": "Professionnel"
        },
        "starter": {
          "name": "Débutant"
        }
      },
      "popular": "Le plus populaire",
      "startBtn": "Commencer"
    },
    "profile": {
      "fields": {
        "company": "Entreprise",
        "email": "E-mail",
        "license": "Licence",
        "memberSince": "Membre depuis",
        "role": "Rôle",
        "username": "Nom d’utilisateur"
      },
      "kicker": "Compte",
      "leadMobile": "Détails du compte et sécurité.",
      "password": {
        "confirm": "Confirmer le nouveau mot de passe",
        "current": "Mot de passe actuel",
        "errors": {
          "allFieldsRequired": "Tous les champs sont requis",
          "failed": "Échec du changement de mot de passe",
          "passwordsDontMatch": "Les nouveaux mots de passe ne correspondent pas",
          "passwordTooShort": "Le mot de passe doit contenir au moins 6 caractères"
        },
        "new": "Nouveau mot de passe",
        "save": "Changer le mot de passe",
        "success": "Mot de passe modifié avec succès",
        "title": "Changer le mot de passe"
      },
      "roles": {
        "companyAdmin": "Admin entreprise",
        "systemAdmin": "Admin système",
        "user": "Utilisateur"
      },
      "security": {
        "changePassword": "Changer le mot de passe",
        "password": "Mot de passe",
        "passwordHint": "Changez votre mot de passe pour sécuriser votre compte",
        "title": "Sécurité"
      },
      "subtitle": "Gérez les paramètres de votre compte",
      "title": "Profil",
      "unverified": "Non vérifié",
      "verified": "Vérifié"
    },
    "sidebar": {
      "admin": "Admin système",
      "company": "Mon entreprise",
      "connections": "Connexions",
      "dashboard": "Tableau de bord",
      "downloads": "Téléchargements",
      "logout": "Déconnexion",
      "logoutConfirm": "Voulez-vous vraiment vous déconnecter ?",
      "logoutConfirmTitle": "Se déconnecter ?",
      "mobileNav": "Navigation principale",
      "more": "Plus",
      "premiumPackage": "Forfait premium entreprise",
      "profile": "Profil",
      "short": {
        "admin": "Admin",
        "apps": "Apps",
        "company": "Entreprise",
        "help": "Aide",
        "home": "Accueil",
        "links": "Liens"
      },
      "tickets": "Support",
      "upgradeCta": "Améliorer",
      "viewPlanCta": "Voir le forfait"
    },
    "systemAdmin": {
      "back": "Retour",
      "companies": {
        "deleteFailed": "Échec de la suppression de l’entreprise",
        "deleteSuccess": "Entreprise supprimée avec succès",
        "licenseUpdateFailed": "Échec de la mise à jour de la licence",
        "licenseUpdateSuccess": "Licence mise à jour avec succès",
        "loadDetailsFailed": "Échec du chargement des détails",
        "updateFailed": "Échec de la mise à jour de l’entreprise",
        "updateSuccess": "Entreprise mise à jour avec succès"
      },
      "endpoints": {
        "col": {
          "agent": "Agent",
          "heartbeat": "Dernier heartbeat",
          "load": "Charge",
          "location": "Emplacement",
          "node": "Nœud",
          "status": "Statut"
        },
        "empty": "Aucun endpoint",
        "emptyLead": "Créez une clé d’enregistrement et embarquez un agent pour voir les nœuds ici.",
        "lead": "Statut agent réel via websocket + heartbeat — pas de drapeaux DB obsolètes.",
        "loading": "Chargement des endpoints…",
        "open": "Ouvrir les serveurs",
        "title": "Points de terminaison"
      },
      "kicker": "Plan de contrôle",
      "leadMobile": "Santé de la plateforme et modules admin.",
      "menuLabel": "Modules admin",
      "open": "Ouvrir",
      "openLogs": "Voir les journaux",
      "openServers": "Gérer les serveurs",
      "servers": {
        "addServer": "Déployer un serveur",
        "agentStatus": {
          "connected": "Connecté",
          "disconnected": "Déconnecté",
          "pending": "En attente"
        },
        "card": {
          "approve": "Approuver",
          "load": "Charge",
          "reject": "Rejeter",
          "settings": "Paramètres",
          "users": "Utilisateurs"
        },
        "deleteError": "Une erreur s’est produite lors de la suppression du serveur",
        "deleteSuccess": "Serveur supprimé avec succès !",
        "editBeforeApprove": "Configurer avant d’approuver",
        "editPending": {
          "approveBtn": "Approuver et enregistrer",
          "location": "Emplacement",
          "name": "Nom du serveur",
          "selectLocation": "Sélectionnez un emplacement",
          "visibilityNote": "Le serveur sera masqué aux utilisateurs après approbation. Vous pourrez le rendre visible plus tard."
        },
        "empty": {
          "description": "Déployez un serveur via SSH pour enregistrer un agent ici.",
          "title": "Aucun serveur"
        },
        "filter": {
          "all": "Tous",
          "label": "Pays"
        },
        "keyCreateError": "Une erreur s’est produite lors de la création de la clé",
        "keyCreateSuccess": "Nouvelle clé d’enregistrement créée !",
        "keyRevokeError": "Une erreur s’est produite lors de la révocation de la clé",
        "keyRevokeSuccess": "Clé révoquée avec succès !",
        "loading": "Chargement des serveurs…",
        "locationCreateSuccess": "Emplacement créé avec succès !",
        "locationDeleteError": "Une erreur s’est produite lors de la suppression de l’emplacement",
        "locationDeleteSuccess": "Emplacement supprimé avec succès !",
        "locationSaveError": "Une erreur s’est produite lors de l’enregistrement de l’emplacement",
        "locationUpdateSuccess": "Emplacement mis à jour avec succès !",
        "pendingModal": {
          "approve": "Approuver",
          "noPending": "Aucun serveur en attente",
          "reject": "Rejeter",
          "title": "Serveurs en attente"
        },
        "retry": "Réessayer",
        "saveError": "Une erreur s’est produite lors de l’enregistrement des paramètres",
        "stats": {
          "activeUsers": "Utilisateurs actifs",
          "avgLoad": "Charge moy.",
          "onlineServers": "En ligne",
          "totalServers": "Total"
        },
        "status": {
          "maintenance": "Maintenance",
          "offline": "Hors ligne",
          "online": "En ligne"
        },
        "subtitle": "Déployez des edges via SSH, approuvez les nœuds, configurez le failover optionnel, gérez les clés.",
        "title": "Serveurs",
        "toggleError": "Une erreur s’est produite lors du changement d’état du serveur",
        "visibilityError": "Échec du basculement de visibilité",
        "visibilityToggled": "Visibilité du serveur mise à jour"
      },
      "stats": {
        "companies": "Entreprises",
        "connections": "Tunnels actifs",
        "errors": "Erreurs 24h",
        "liveAgents": "Agents en direct",
        "openTickets": "Tickets ouverts",
        "servers": "Serveurs en ligne",
        "users": "Utilisateurs",
        "visible": "Nœuds visibles"
      },
      "statsError": "Impossible de charger les métriques en direct",
      "subtitle": "Santé de la plateforme en direct — utilisateurs, agents, endpoints et signaux opérationnels.",
      "title": "Admin système"
    },
    "tickets": {
      "active": "Actifs",
      "allTickets": "Tous",
      "attach": "Joindre",
      "attachment": "Pièce jointe",
      "category": "Catégorie",
      "chooseFile": "Choisir un fichier",
      "closedNotice": "Ce ticket est fermé. Ouvrez-en un nouveau si vous avez encore besoin d’aide.",
      "created": "Ticket créé avec succès ! Ticket #{{number}}",
      "createFirst": "Créez votre premier ticket",
      "createTicket": "Créer un ticket",
      "createTicketTitle": "Dites-nous ce qui s’est passé",
      "emailShort": "E-mail",
      "fileTooLarge": "Fichier trop volumineux. Taille max. 2 Mo",
      "fillRequired": "Veuillez remplir le sujet et le message",
      "heroLead": "Ouvrez un ticket pour connexion, compte ou facturation. Notre équipe répond dans ce fil.",
      "heroTitle": "Comment pouvons-nous vous aider ?",
      "inProcess": "En cours",
      "kicker": "Support",
      "leadMobile": "Ouvrez un ticket ou choisissez-en un ci-dessous.",
      "loading": "Chargement des tickets…",
      "message": "Message",
      "messagePlaceholder": "Décrivez votre problème en détail…",
      "messages": "messages",
      "messageSent": "Message envoyé",
      "newTicket": "Nouveau ticket",
      "noTickets": "Aucun ticket",
      "noTicketsDesc": "Créez un ticket et nous ferons le suivi dans cette boîte.",
      "open": "Ouvert",
      "priority": "Priorité",
      "priorityHigh": "Élevée",
      "priorityLow": "Basse",
      "priorityNormal": "Normale",
      "priorityUpdated": "Priorité mise à jour",
      "priorityUrgent": "Urgente",
      "replyPlaceholder": "Écrire une réponse…",
      "search": "Rechercher des tickets…",
      "selectCategory": "Sélectionnez une catégorie",
      "selectTicket": "Sélectionnez un ticket",
      "selectTicketDesc": "Choisissez une conversation à gauche, ou ouvrez une nouvelle demande.",
      "send": "Envoyer",
      "solved": "Résolu",
      "statusUpdated": "Statut mis à jour",
      "subject": "Sujet",
      "subjectPlaceholder": "Brève description de votre problème",
      "submit": "Soumettre le ticket",
      "supportTeam": "Support",
      "total": "Total",
      "declined": "Refusé",
      "topicConnectTitle": "Problème de connexion",
      "topicConnectHint": "Le VPN ne se connecte pas ou se coupe",
      "topicConnectSubject": "Problème de connexion",
      "topicAccountTitle": "Compte et accès",
      "topicAccountHint": "Utilisateurs, invitations ou connexion",
      "topicAccountSubject": "Compte et accès",
      "topicBillingTitle": "Plan et facturation",
      "topicBillingHint": "Licences, factures ou mises à niveau",
      "topicBillingSubject": "Plan et facturation",
      "justNow": "à l’instant",
      "minsAgo": "{{n}} min",
      "hoursAgo": "{{n}} h",
      "daysAgo": "{{n}} j",
      "detailsLabel": "Détails :"
    },
    "upgrade": {
      "buy": "Acheter et améliorer",
      "current": "Plan actuel",
      "kicker": "Forfait entreprise",
      "leadAdmin": "Choisissez un plan, finalisez le paiement démo, et votre entreprise est améliorée instantanément avec une facture.",
      "leadMember": "Seul un utilisateur avec permission de gestion entreprise peut améliorer ce forfait.",
      "loading": "Chargement du plan…",
      "lockedBody": "Une personne avec permission de gestion entreprise peut changer le forfait. Demandez à votre admin.",
      "lockedTitle": "Amélioration indisponible",
      "plans": {
        "basic": "Basique",
        "enterprise": "Entreprise",
        "free": "Gratuit",
        "pro": "Pro"
      },
      "title": "Forfait premium",
      "leadAdminShort": "Choisir un plan → paiement démo → amélioration.",
      "leadMemberShort": "Seul un admin entreprise peut améliorer.",
      "demoNote": "Paiement démo : les cartes ne sont pas débitées. Après paiement, une facture est créée et le plan s’active immédiatement."
    },
    "connectModal": {
      "serverFallback": "serveur",
      "titleConnect": "Connecter · {{location}}",
      "titleConnected": "Connecté · {{location}}",
      "kickerReady": "Tunnel prêt",
      "kickerSecure": "Tunnel sécurisé",
      "close": "Fermer",
      "load": "Charge",
      "protocol": "Protocole",
      "configReady": "Config prête",
      "waiting": "En attente",
      "leadBefore": "Générez une configuration WireGuard à usage unique pour ce point de terminaison. Scannez le QR sur mobile ou importez le fichier sur bureau.",
      "step1": "Les clés peer chiffrées sont créées côté serveur",
      "step2": "La config inclut DNS et routage d’endpoint",
      "step3": "Importez une fois — activez le tunnel dans WireGuard",
      "leadAfter": "Votre profil VPN est prêt. Scannez avec l’app WireGuard ou téléchargez le fichier de config.",
      "tabQr": "Code QR",
      "tabConfig": "Texte de config",
      "scanHint": "Ouvrez WireGuard → Scannez le QR",
      "copied": "Copié",
      "copyConfig": "Copier la config",
      "vpnIp": "IP VPN",
      "server": "Serveur",
      "dns": "DNS",
      "cancel": "Annuler",
      "connecting": "Connexion…",
      "connect": "Connecter",
      "downloadConf": "Télécharger .conf",
      "done": "Terminé",
      "connectFailed": "Échec de la connexion"
    },
    "careers": {
      "title": "Carrières",
      "subtitle": "Nous grandissons avec des personnes qui gardent le produit calme et les opérations précises.",
      "whyTitle": "Pourquoi ArcVPN",
      "whyFocusTitle": "Focus",
      "whyFocusBody": "Travaillez près des vrais problèmes clients — pas de roadmaps bruyantes.",
      "whyOwnershipTitle": "Responsabilité",
      "whyOwnershipBody": "Petites équipes, responsabilités claires, impact visible.",
      "whyFlexibilityTitle": "Flexibilité",
      "whyFlexibilityBody": "Travail hybride avec un rythme orienté résultats.",
      "whyLearningTitle": "Apprentissage",
      "whyLearningBody": "Progressez en sécurité, réseaux et produit.",
      "openTitle": "Postes ouverts",
      "emptyTitle": "Aucun poste ouvert pour le moment",
      "emptyBody": "Si quelque chose vous parle, envoyez votre CV ou LinkedIn. Nous vous contacterons quand un rôle correspondant s’ouvrira.",
      "cta": "Envoyer un e-mail",
      "email": "info@arcyintel.com",
      "mailSubject": "Candidature ArcVPN"
    }
  },
};
